import external from './external';
export default {
    sv: {
        external: external.sv,
        components: {
            menuBar: {
                landlord: {
                    profile: 'Profil',
                    templates: 'Mallar'
                },
                company: {
                    register: 'Registrera sökuppdrag',
                    change: 'Ändra kontaktuppgifter'
                },
                overview: 'Översikt',
                logout: 'Logga ut',
            },
            createEstateCard: {
                title: 'Fler bostäder för uthyrning?',
                text: 'Det är helt gratis för dig att annonsera ut en eller flera bostäder för uthyrning via vår webbplats.',
                button: 'Skapa ny bostadsannons'
            },
            tabler: {
                pdfs: {
                    inventory: 'Inventarielista',
                    inc_en: '',
                    inc_sv: 'Besittningsskydd',
                    power: 'Fullmakt',
                    survey_protocol: 'Besiktningsprotokoll',
                }
            }
        },
        views: {
            login: {
                title: 'Logga in',
                customer_number: 'Kundnummer',
                password: 'Lösenord',
                sign_in: 'Logga in',
                forgot_password: 'Glömt dina inloggningsuppgifter?',
                register_title: 'Har du inget konto? Skapa ett här',
                sublet: 'Hyra ut',
                corporate: 'Hitta företagsbostad'
            },
            dashboard: {
                landlord: {
                    title: 'Mina sidor',
                    welcome: 'Välkommen',
                    description: 'Här kan du administrera din annons, se hyreskontrakt och få en ekonomisk överblick. Du kan även skapa fler annonser om du har fler bostäder som du vill hyra ut.',
                    first_estate_being_reviewed_par1: 'Tack för att du annonserar din bostad för uthyrning via Bostad Direkt. Så fort vi har granskat din annons publiceras den på vår webbplats. Vanligtvis tar vår granskning maximalt en arbetsdag.',
                    first_estate_being_reviewed_par2: 'En av våra handläggare på Bostad Direkt kommer att kontakta dig så fort ett företag visat intresse för din bostad.'
                },
                company: {
                    title: 'Mina sidor för'
                }
            },
            profile: {
                title: 'Dina kontaktuppgifter',
                btnSave: 'Spara',
                contact_person_title: 'Kontaktperson',
                contact_person: 'Ange en annan kontaktperson'
            },
            templates: {
                title: 'Mallar',
                description: 'Här nedan kan du ladda ner mallar och formulär i pdf-format. Hyrs bostaden ut möblerad bör en inventarielista upprättas över de inventarier som finns i bostaden. Om en hyresrättslägenhet hyrs ut längre än två år till en och samma hyresgäst rekommenderar vi att ni fyller i blanketten "Besittningsskydd" <br /> <br /> Om någon annan hjälper dig med din uthyrning rekommenderar vi att ni tillsammans skapar en fullmakt med hjälp av vår mall nedan.'
            },
            create_estate: {
                step_two: {
                    title: 'Skapa din annons',
                    propertyDetails: {
                        title: 'Fastighetsuppgifter',
                        copyAddress: 'Samma som kontaktadress',
                        areaTitle: 'Områdesbeskrivning'
                    },
                    housingInformation: {
                        title: 'Bostadsinformation'
                    },
                    equipments: {
                        equipment: 'Utrustning',
                        includes: 'Ingår i hyran'
                    },
                    housingDescription: {
                        title: 'Din egna bostadsbeskrivning'
                    },
                    requirements: {
                        title: 'Uthyrningsperiod och krav på hyresgäst'
                    }
                },
                step_three: {
                    title: 'Ladda upp bilder',
                    sub_title: 'Visa din bostad med bilder!',
                    text: 'För att din bostad ska få bra uppmärksamhet och snabbt bli uthyrd bör du publicera fina bilder på den. Ladda gärna upp en bild per rum, det kan även vara bra att visa samma rum från olika perspektiv. <br /> <br /> Skriv även en kort förklaring till respektive bild i Bildtextfälten, Exempelvis; Vardagsrum, Kök, Utsikt från balkong etc.<br />Bilderna får vara max 4 mb vardera.'
                },
                step_four: {
                    title: 'Granska och spara',
                    sub_title: 'Kontrollera annons och ändra vid behov',
                    text: 'Granska dina uppgifter och spara annonsen. Kontrollera din annons och ändra vid behov.'
                },
                save_btn: 'Spara & fortsätt'
            },
            company: {
                contact_details: {
                    title: 'Kontaktuppgifter - Företag',
                    text: 'Klicka på länken "Ändra kontaktuppgifter" om du vill ändra uppgifterna till kontaktpersonen eller uppdatera någon annan information som har med ert företag att göra.',
                },
                housing_requests: {
                    title: 'Bostadsspecifikation',
                    text: 'Här ser du samtliga personer på ert företag som söker bostad. Genom att klicka på länken "Ändra sökkriterier" så kan du ändra respektive persons önskemål på bostaden och genom att klicka på länken "Visa förslag" så ger vi dig förslag på de bostäder som vi tror kan vara intressanta för just denna person.'
                },
                viewings: {
                    title: 'Inbokade visningar',
                    text: 'Här ser du samtliga visningar som ert företag är inbokade på.'
                },
                register_mediation: {
                    title_one: 'Boendeperson och bostad',
                    title_two: 'Övrigt om boendepersonen',
                    title_three: 'Önskemål på bostad'
                },
                contact: {
                    title_one: 'Företagsuppgifter',
                    title_two: 'Behörig beställare',
                    text_two: 'En behörig beställare är en person på företaget som har rätt att beställa tjänster och ingå avtal i företagets namn.',
                    text_three: 'Bostad Direkt hanterar de personuppgifter som du uppgett i registreringsformuläret för att kunna leverera sin service till dig samt hjälpa dig att ingå korrekta hyresavtal. Om en obligatorisk personuppgift saknas för att kunna ingå ett hyresavtal hämtas denna in vid tillfället när avtalet upprättas. <br /> <br /> Bostad Direkt samlar enbart in uppgifter som är relevanta för tjänsten och säljer aldrig vidare din information till tredje part. Dina uppgifter hanteras enbart av Bostad Direkt och dess leverantörer som betjänar Bostad Direkts informationssystem samt den part som har rätt att ta del av uppgifterna vid ingående av hyresavtal, t.ex. din motpart i avtalet. <br /> <br /> Vår fullständiga integritetspolicy går att läsa <a href="#">här</a>.'
                },
                agent: 'Er handläggare',
                agree: 'Jag har läst och accepterat avtalet'
            },
            show_interest: {
                headline: 'Skicka intresseanmälan',
                register_account_first_text: '<p>Innan vi kan boka en bostadsvisning måste ditt företag vara registrerat hos oss.</p><p>Anmäl ditt företag till vår Företagsservice <a href="/sv/bostadsservice-for-foretag">här</a>.</p>',
                choose_person_label: 'För vilken bostadssökande gäller visningen?',
                note_label: 'Information om den bostad du visar intresse i samt meddelandet i nedanstående ruta kommer att skickas till din handläggare. Detta meddelande kan t.ex. innehålla förfrågningar till hyresvärden eller förslag på när du kan tänka dig att gå på visning.',
                request_was_sent_headline: 'Tack för din bokning!',
                request_was_sent_text: 'Din handläggare kommer att kontakta dig inom kort.',
            }
        },
        states: {
            waiting: 'Väntar'
        },
        agree_to_terms: 'Jag har läst och accepterat avtalet',
        ssn: 'Personnummer',
        ssn_non_swedish: 'Utländskt personummer eller organisationsnummer',
        person_singular: 'person',
        person_plural: 'personer',
        first_name: 'Förnamn',
        last_name: 'Efternamn',
        street_address: 'Gatuadress',
        street_number: 'Gatunr.',
        apartment_number: 'Lägenhetsnr.',
        care_of: 'C/o',
        post_adress: 'Postaddress',
        adress: 'Address',
        zip_code: 'Postnr',
        zip_code_non_swedish: 'Utländskt postnr',
        closest_area: 'Närmaste station/hållplats',
        close_x: 'Stäng X',
        city: 'Postort',
        email: 'E-post',
        email_again: 'Repetera e-post',
        phone: 'Telefon',
        phone_work: 'Telefon, arbete',
        cellphone: 'Mobil',
        residence: 'Bostadstyp',
        rooms: 'Antal rum',
        room: 'Rum',
        bedrooms: 'Antal sovrum',
        bedroom: 'Sovrum',
        furnishing: 'Möblering',
        balcony: 'Balkong/uteplats',
        biarea: 'Biyta, kvm',
        lot_size: 'Tomtarea, kvm',
        size_sqm: 'Boyta, kvm',
        kitchen_type: 'Typ av kök',
        year_built: 'Byggnadsår',
        floor: 'Vilken våning i fastighet',
        total_floors: 'Totalt antal våningar',
        monthly_rent: 'Månadshyra',
        advertised_rent: 'Utannonserad hyra',
        from: 'Tillträde',
        until: 'Frånträde',
        requisites: 'Krav på hyresgäst',
        requirement: 'Krav',
        included: 'Ingår',
        extension: 'Förlängningsmöjlighet',
        loading: 'Laddar',
        yes: 'Ja',
        no: 'Nej',
        elevator: 'Hiss',
        rent: 'Hyra',
        rental_period: 'Hyresperiod',
        extension_possibility: 'Förlängningsmöjlighet',
        equipment: 'Utrustning',
        published_updated: 'Publicerad / uppdaterad',
        published: 'Publicerad',
        last_updated: 'Senast uppdaterad',
        stairs_shorthand: 'tr',
        show_interest_button: 'Visa intresse',
        login_to_show_interest: 'Du måste vara inloggad för att kunna visa intresse för denna bostad',
        password: 'Lösenord',
        password_again: 'Ange lösenord igen',
        inc_chars: 'Inkl. bokstäver',
        inc_number: 'Inkl. nummer',
        inc_password_length: 'Minst sex tecken',
        password_helper_text: 'Ange ett lösenord som består av både bokstäver och siffror och är minst sex tecken långt.',
        company_contact: 'Företagskontakt',
        home_seeker: 'Bostadssökande',
        housing: 'Bostadstyp',
        change: 'Ändra',
        object: 'Objekt',
        object_number: 'Obj.nr',
        date: 'Datum',
        agent: 'Handläggare',
        status_of: 'Status',
        customer_service: 'Kundtjänst',
        name: 'Namn',
        new_assignment: 'Nytt sökuppdrag',
        document: 'Dokument',
        fax: 'Fax nummer',
        number_of_tenants: 'Antal boende',
        has_animals: 'Har djur',
        is_smoker: 'Är rökare',
        yyyy_mm_dd: 'åååå-mm-dd',
        move_in_date: 'Inflyttningsdatum (åååå-mm-dd)',
        desired_period: 'Önskad hyresperiod',
        min_no_of_rooms: 'Minsta antal rum',
        min_no_of_sqm: 'Minsta area, kvm',
        shortest_period: 'Kortaste period',
        max_rent: 'Maxhyra',
        company_name: 'Företagsnamn',
        department: 'Avdelning',
        org_nr: 'Organisationsnummer',
        industry: 'Bransch',
        contact_information: 'Kontaktinformation',
        contact_person: 'Annan kontaktperson',
        other_contact_person: 'Annan kontaktperson',
        residence_information: 'Bostadsinformation',
        area_description: 'Områdesbeskrivning',
        object_description: 'Bostadsbeskrivning',
        pictures: 'Bilder',
        no_data: 'Ingen data',
        area: 'Område',
        change_ad: 'Ändra annons',
        status: 'Status',
        show_ad: 'Visa annons',
        how_long: 'Hur länge',
        save: 'Spara',
        booking_request: 'Bokningsförfrågan',
        number_of_estates: 'Antal bostäder',
        other_about_area: 'Övrigt, t ex budget, tillträdesdatum, önskad möblering',
        form_technical_error: 'Just nu upplever vi tekniska bekymmer! Vänligen försök senare igen.',
        now: 'Omg.',
        until_further_notice: 'tillsvidare',
        other_requirements: 'Övriga önskemål',
        choose_county_area: 'Välj län och område',
        months: 'månader',
        house: 'Hus',
        apartment: 'Lägenhet',
        both: 'Båda',
        furnished: 'Möblerad',
        unfurnished: 'Omöblerad',
        partly_furnished: 'Delvis möblerad',
        email_not_match: 'E-postaddressen matcher inte.',
        choose_area: 'Välj område',
        choose: 'Välj'
    },
    en: {
        external: external.en,
        components: {
            menuBar: {
                landlord: {
                    profile: 'Profile',
                    templates: 'Templates'
                },
                company: {
                    register: 'Register mediation assigment',
                    change: 'Change contact details'
                },
                overview: 'Overview',
                logout: 'Log out',
            },
            createEstateCard: {
                title: 'More housing available for subletting?',
                text: 'Advertising one or more properties for subletting via our website is free of charge.',
                button: 'Create new estate ad'
            },
            tabler: {
                pdfs: {
                    inventory: 'Inventory list',
                    inc_en: 'Waiving your security of tenure - Instruction in English',
                    inc_sv: 'Waiving your security of tenure (in Swedish)',
                    power: 'Power of attorney',
                    survey_protocol: 'Survey protocol',
                }
            }
        },
        views: {
            login: {
                title: 'Sign in',
                customer_number: 'Customer Number',
                password: 'Password',
                sign_in: 'Log in',
                forgot_password: 'Forgot your credentials?',
                register_title: 'Do not have an account? Create one here',
                sublet: 'Sublet',
                corporate: 'Find a corporate residence'
            },
            dashboard: {
                landlord: {
                    title: 'My Pages',
                    welcome: 'Welcome',
                    description: 'Here you can edit your advert, see potential tenants that have shown interest in your advert and handle your contracts as well as see the status of any rent payments. You can also create more adverts if you have other properties that you would like to sublet.',
                    first_estate_being_reviewed_par1: 'Thank you for using Bostad Direkt. Once we have reviewed your ad it will be published on our website. This is usually done within one business day.',
                    first_estate_being_reviewed_par2: 'One of our agents will contact you when there is interest in your property.'
                },
                company: {
                    title: 'My pages for'
                }
            },
            templates: {
                title: 'Templates',
                description: 'Here you can download templates and forms as editable PDF files. <br /> If the sublet includes furniture, an inventory list should be made of what is included in the lease. If the lease concerns a rental property to the same tenant for more than two years we recommend that you fill in the form entitled "Waiving your security of tenure". This form, which is issued by the Rent Tribunal, is only available in Swedish, so please read the instructional PDF available below as well.'
            },
            profile: {
                title: 'Your contact details',
                btnSave: 'Ok, save',
                contact_person_title: 'Contact person',
                contact_person: 'Enter another contact person',
            },
            create_estate: {
                step_two: {
                    title: 'Create your ad',
                    propertyDetails: {
                        title: 'Estate information',
                        copyAddress: 'Copy estate address from contact address',
                        areaTitle: 'Area description'
                    },
                    housingInformation: {
                        title: 'Residence information'
                    },
                    equipments: {
                        equipment: 'Equipment',
                        includes: 'Included in rent'
                    },
                    housingDescription: {
                        title: 'Your own description of the property'
                    },
                    requirements: {
                        title: 'Uthyrningsperiod och krav på hyresgäst'
                    }
                },
                step_three: {
                    title: 'Upload images',
                    sub_title: 'Show off your residence using images!',
                    text: 'To make your advert more interesting and to ensure a quicker successful sublet you should always add pictures of the residence to your advert.<br /><br /> We recommend you to add at least two pictures in order to give you and your future tenant the opportunity to get in touch quicker. <br />Each image must not exceed 4 mb in size.'
                },
                step_four: {
                    title: 'Review and save',
                    sub_title: 'Review your ad',
                    text: 'Make sure that all entered information is correct and make any changes if needed.'
                },
                save_btn: 'Save & continue'
            },
            company: {
                contact_details: {
                    title: 'Contact details - Company',
                    text: 'Click on the "Change contact details" link if you wish to change details for the contact person or to update any other information about your company.',
                },
                housing_requests: {
                    title: 'Housing requests',
                    text: 'This shows all the people at your company who are looking for accommodation. Click on the "Edit search criterias" link to change a person\'s housing requests. Clicking on the "Show suggestions" link displays properties that we believe may be of interest to that particular person.'
                },
                viewings: {
                    title: 'Viewings',
                    text: 'This displays all the viewings for which your company is currently booked.'
                },
                register_mediation: {
                    title_one: 'Tenant',
                    title_two: 'About the tenant',
                    title_three: 'Residential wishes'
                },
                contact: {
                    title_one: 'Company information',
                    title_two: 'Authorized Individual',
                    text_two: 'An authorized individual is someone who is able to order services and enter agreements on behalf of the company.',
                    text_three: 'Bostad Direkt stores the personal details that you have provided during registration in order to provide their services to you as well as help you enter into correct leasing agreements. If any details that are mandatory to enter an agreement is not provided, this will be collected when a leasing agreement is drafted. <br /> <br /> Bostad Direkt only stores personal details that are relevant for the service provided and will never sell your information to a third party. Your details are only able to be accessed by Bostad Direkt and suppliers that service Bostad Direkt’s technical platform, as well as any party that has the right to access your personal details when entering into a leasing agreement i.e. your counter party in the agreement. <br /> <br /> For more information, please see our Privacy Policy <a href="#">here</a>.'
                },
                agent: 'Your residential agent',
                agree: 'I have read and accepted the agreement'
            },
            show_interest: {
                headline: 'Show interest',
                register_account_first_text: '<p>Before you book a viewing, we need to have a corporate service registered with you.</p><p>Register a corporate service <a href="/en/residential-services-for-companies">here</a>.</p>',
                choose_person_label: 'Who is interested in this residence?',
                note_label: 'The details of the residence you are showing interest in, as well as anything entered in the text box below this message will be sent to your residential agent. Any questions you might have for the landlord, as well as requests for any specific times for a viewing of the residence should be added in the box below.',
                request_was_sent_headline: 'Thank you for your booking!',
                request_was_sent_text: 'Your agent will contact you shortly.',
            }
        },
        states: {
            waiting: 'Waiting'
        },
        agree_to_terms: 'I have read and accepted the agreement',
        ssn: 'Social security number',
        ssn_non_swedish: 'Non Swedish personal ID number or organization number',
        person_singular: 'person',
        person_plural: 'persons',
        first_name: 'First name',
        last_name: 'Surname',
        street_address: 'Street',
        street_number: 'Street no.',
        apartment_number: 'Apt. no.',
        care_of: 'Care of',
        post_adress: 'Postal address',
        adress: 'Adress',
        zip_code: 'Zip code',
        zip_code_non_swedish: 'Non-swedish postal code',
        closest_area: 'Nearest station/stop',
        close_x: 'Close X',
        city: 'City',
        email: 'E-mail',
        email_again: 'Repeat e-mail',
        phone: 'Phone',
        phone_work: 'Phone, work',
        cellphone: 'Cellphone',
        residence: 'Type of residence',
        rooms: 'Number of rooms',
        room: 'Room',
        bedrooms: 'Number of bedrooms',
        bedroom: 'Bedrooms',
        furnishing: 'Furnishing',
        balcony: 'Balcony/Porch',
        biarea: 'Non-living space, sqm',
        lot_size: 'Lot size, sqm',
        size_sqm: 'Size, sqm',
        kitchen_type: 'Kitchen type',
        year_built: 'Year built',
        floor: 'Which floor in the building',
        total_floors: 'Total Amount of Floors',
        monthly_rent: 'Monthly rent',
        advertised_rent: 'Advertised rent',
        from: 'From',
        until: 'Until',
        requisites: 'Requisites',
        requirement: 'Requirements',
        included: 'Included',
        extension: 'Extension possibility',
        loading: 'Loading',
        yes: 'Yes',
        no: 'No',
        elevator: 'Elevator',
        rent: 'Rent',
        rental_period: 'Rental period',
        extension_possibility: 'Extension possibility',
        equipment: 'Equipment',
        published_updated: 'Published / updated',
        published: 'Published',
        last_updated: 'Last updated',
        stairs_shorthand: 'stairs',
        show_interest_button: 'Show interest',
        login_to_show_interest: 'You have to be logged in to show your interest in this estate.',
        password: 'Password',
        password_again: 'Repeat the password',
        inc_chars: 'Incl. letters',
        inc_number: 'Incl. numbers',
        inc_password_length: 'Atleast six chars',
        password_helper_text: 'Enter a password that is atleast six characters long and consists of both letters and numbers.',
        company_contact: 'Company contact',
        home_seeker: 'Home seeker',
        housing: 'Housing',
        change: 'Change',
        object: 'Object',
        object_number: 'Object number',
        date: 'Date',
        agent: 'Agent',
        status_of: 'Status of',
        customer_service: 'Customer service',
        name: 'Name',
        new_assignment: 'New assigment',
        document: 'Document',
        fax: 'Fax number',
        number_of_tenants: 'Number of tenants',
        has_animals: 'Has pets',
        is_smoker: 'Is smoker',
        yyyy_mm_dd: 'yyyy-mm-dd',
        move_in_date: 'Move in data (YYYY-MM-DD)',
        desired_period: 'Desired period',
        min_no_of_rooms: 'Min no of rooms',
        min_no_of_sqm: 'Min no of sqm',
        shortest_period: 'Shortest period',
        max_rent: 'Max rent',
        company_name: 'Company name',
        department: 'Department',
        org_nr: 'Organization number',
        industry: 'Industry',
        contact_information: 'Contact Information',
        contact_person: 'Contact person',
        other_contact_person: 'Other contact person',
        residence_information: 'Residence information',
        area_description: 'Area Description',
        object_description: 'Object description',
        pictures: 'Pictures',
        no_data: 'No data',
        area: 'Area',
        change_ad: 'Change ad',
        status: 'Status',
        show_ad: 'Show ad',
        how_long: 'How long',
        save: 'Save',
        number_of_estates: 'Number of estates',
        booking_request: 'Booking request',
        other_about_area: 'Other, ie budget, moving in date, desired furniture',
        form_technical_error: 'Right now we are experiencing technical problems! Please try again later.',
        now: 'Now',
        until_further_notice: 'until further notice',
        other_requirements: 'Other requirements',
        choose_county_area: 'Choose county and area',
        months: 'months',
        house: 'House',
        apartment: 'Apartment',
        both: 'Both',
        furnished: 'Furnished',
        unfurnished: 'Unfurnished',
        partly_furnished: 'Delvis möblerad',
        email_not_match: 'E-mail does not match.',
        choose_area: 'Select area',
        choose: 'Choose'
    }
};
